import { ScheduleFormInfoB50 } from './ScheduleFormInfoB50';
import { ScheduleFormInfoCV50 } from './ScheduleFormInfoCV50';

interface ScheduleFormInfoProps {
  isB50: boolean;
}

export const ScheduleFormInfo = ({ isB50 }: ScheduleFormInfoProps): JSX.Element =>
  isB50 ? <ScheduleFormInfoB50 /> : <ScheduleFormInfoCV50 />;
